import { render } from "./mOmicsResult.vue?vue&type=template&id=70fa9a6a&scoped=true"
import script from "./mOmicsResult.vue?vue&type=script&lang=js"
export * from "./mOmicsResult.vue?vue&type=script&lang=js"

import "./mOmicsResult.vue?vue&type=style&index=0&id=70fa9a6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fa9a6a"]])

export default __exports__